const ENDPOINT = {
  MEDIA: {
    MULTIPLE: '/media/multiple',
    CONTRACT: '/media/contract',
    VIDEO: '/media/video',
  },

  SETTING: '/settings',
  LIMIT_SETTING: (limit) => `/settings?limit=${limit}`,

  // PLACE
  GLOBAL_PLACES: '/places/global',
  MY_PLACE: '/places/me',
  INTRANET_PLACES: '/places/intranet',
  PLACE: (id) => `/places/${id}`,
  PLACE_PREVIEW_IMAGE: (id) => `/places/${id}/preview-image`,
  PLACE_IMAGES: (id) => `/places/${id}/images`,
  PLACE_PUBLIC_IMAGES: (id) => `/places/${id}/public-images`,
  PLACE_VIDEO: (id) => `/places/${id}/video`,
  PLACE_SERVICES: (id) => `/places/${id}/services`,
  PLACE_SERVICE_FEE: (id) => `/places/${id}/service-fee`,
  PLACE_OTHER_FEES: (id) => `/places/${id}/other-fees`,
  EDIT_PLACE_OTHER_FEE: (placeId, otherFeeId) =>
    `/places/${placeId}/other-fees/${otherFeeId}`,
  PLACE_PARKING_SERVICE: (id) => `/places/${id}/parking-service`,
  PLACE_NEARBY_LANDMARKS: (id) => `/places/${id}/nearby-landmarks`,
  PLACE_DETAIL: (id) => `/places/${id}`,
  PLACE_TODAY_BOOKINGS: (id) => `/places/${id}/today-bookings`,
  PLACE_STATUS: (id) => `/places/${id}/status`,
  PLACE_CONTRACT: (id) => `/places/${id}/contract`,
  PLACE_FAVORITE: (id) => `/places/${id}/favorite`,
  PLACE_PRICE_TYPES: (id) => `/price-types?place=${id}`,
  EDIT_PLACE_PRICE_TYPES: (priceId, placeId) =>
    `/price-types/${priceId}?place=${placeId}`,
  ROOM_IMAGES: (id) => `/places/${id}/rooms`,
  ROOM_FACILITIES: (id) => `/places/${id}/rooms/facilities`,
  ADD_IMAGES_TO_ROOMS: (id) => `/places/${id}/rooms/images`,
  UPDATE_NUMBER_AVAILABLE_ROOM: (id) => `/places/${id}/rooms/number-available`,
  UPDATE_CLOSE_OPEN_ROOM: (id) => `/places/${id}/rooms/close-open`,
  UPDATE_PRICE_ROOM: (id) => `/places/${id}/rooms/price`,
  CHANGE_POSITION_ROOM_IMAGES: (placeId, roomId) =>
    `/places/${placeId}/room/${roomId}/images`,
  PLACE_POLICY: (placeId) => `/places/${placeId}/policy`,
  CHILDREDN_EXTRA_BED: (placeId) =>
    `/places/${placeId}/policy/children-extra-bed`,
  UPDATE_PLACE_OTA_CREDENTIALS: (placeId) => `/places/${placeId}/ota`,
  CREATE_NEW_PLACE: '/places/create',

  // ROOM
  ROOMS_OF_PLACE: (id) => `places/${id}/rooms`,
  ROOM_DETAIL_OF_PLACE: (placeId, roomId) => `places/${placeId}/room/${roomId}`,
  CREATE_NEW_ROOM: (id) => `/places/${id}/rooms`,
  ROOM_PREVIEW_IMAGE: (placeId, roomId) =>
    `/places/${placeId}/room/${roomId}/preview-image`,
  ROOM_VIDEO: (placeId, roomId) =>
    `/places/${placeId}/room/${roomId}/video`,
  ROOM_PRICE_TYPES: (roomId, placeId) =>
    `/rooms/${roomId}/price-types?place=${placeId}`,
  UPDATE_ROOM_PRICE_TYPES: (roomId, placeId) =>
    `/rooms/${roomId}/price-types/ota?place=${placeId}`,
  PLACE_OTA_RATE_PLANS: (placeId) =>
    `/places/${placeId}/ota/rate-plans`,

  // PROMOTION
  PROMOTION: '/discounts',
  CREATE_PROMOTION: (placeId) => `/discounts?place=${placeId}`,
  DELETE_PROMOTION: (promotionId, placeId) =>
    `/discounts/${promotionId}/end?place=${placeId}`,
  PLACE_PROMOTION: '/promotions',
  USABLE_MARKETING_PROMOTIONS: '/promotions/usable-marketing-promotions',

  FINANCES_BOOKINGS: '/bookings',
  FINANCES_OVERVIEW: '/overview',

  ANALYTICS_PERFORMANCE_CHARTS: '/performance/charts',
  ANALYTICS_PERFORMANCE_STATICS: '/performance/statistics',
  ANALYTICS_PERFORMANCE_OVERVIEWS: '/performance/overviews',

  ANALYTICS_INSIGHTS_OVERVIEW: '/insights/overviews',
  ANALYTICS_ADVANCE_BOOKING_CHARTS:
    '/analytics/insights/advance-booking/charts',
  ANALYTICS_STAY_NIGHTS_CHARTS: '/analytics/insights/stay-nights/charts',
  ANALYTICS_BOOKING_STATUS_RATIO: '/analytics/insights/booking-status-ratio',
  ANALYTICS_MARKET_DEMAND_CHARTS: '/analytics/insights/market-demand/charts',
  ANALYTICS_REVENUE_DISTRIBUTION_ACCOUNT_LEVELS:
    '/analytics/revenue-distribution/account-levels',
  ANALYTICS_REVENUE_DISTRIBUTION_OVERVIEW: '/revenue-distribution/overviews',
  ANALYTICS_REVENUE_DISTRIBUTION_CHART: '/revenue-distribution/charts',
  DISCOVERY_LOCATIONS: '/discover-places',
  DISCOVERY_LOCATION_DETAIL: (id) => `/discover-places/${id}`,

  //
  MANAGER_DISCOVERY_PLACE: '/manager-discovery/place',
  MANAGER_DISCOVERY_PLACE_CREATE: '/manager-discovery/place/create',
  MANAGER_DISCOVERY_PLACE_DETAIL: (id) => `/manager-discovery/place/${id}`,
  MANAGER_DISCOVERY_CATEGORY: '/manager-discovery/category',
  MANAGER_DISCOVERY_DESTINATION: '/manager-discovery/destination',
  MANAGER_DISCOVERY_REVIEW: '/manager-discovery/review',

  // GIFT
  MANAGER_GIFT: '/manager-gifts',
  MANAGER_GIFT_CREATE: '/manager-gifts/create',
  MANAGER_GIFT_LIST: '/manager-gifts/list',
  MANAGER_GIFT_DETAIL_PATH: '/manager-gifts/:id',
  MANAGER_GIFT_DETAIL: (id) => `/manager-gifts/${id}`,
  MANAGER_GIFT_EXCHANGE: '/manager-gifts/exchange',
  MANAGER_GIFT_EXCHANGE_DETAIL: (id) => `/manager-gifts/exchange/${id}`,
  MANAGER_GIFT_VOUCHER_CAMPAIGN: '/manager-gifts/voucher-campaign',
  MANAGER_GIFT_VOUCHER_CAMPAIGN_DETAIL: (id) =>
    `/manager-gifts/voucher-campaign/detail/${id}`,
  MANAGER_GIFT_VOUCHER: '/manager-gifts/voucher',

  // FLIGHT
  MANAGER_FLIGHT_BOOKING: '/manager-flight-bookings',
  MANAGER_FLIGHT_BOOKING_DETAIL_PATH: '/manager-flight-bookings/:id',
  MANAGER_FLIGHT_BOOKING_DETAIL: (id) => `/manager-flight-bookings/${id}`,
  MANAGER_FLIGHT_SETTING: '/manager-flight-settings',
  MANAGER_FLIGHT_REVENUE: '/manager-flight-revenue',

  // PROFILE
  PROFILE: '/profile',
  PROFILE_EXTRANET: '/profile-extranet',
  PROFILE_INTRANET: '/profile-intranet',

  // INTRANET ACCOUNT MANAGEMENT
  MANAGER_INTERNAL_ACCOUNT: '/intranet-administrators',

  // EXTRANET NOTIFICATION
  EXTRANET_NOTIFICATION: '/extranet-notifications',

  // CHAT
  CHAT: '/chat',

  // REVENUE
  REVENUE: '/revenue',

  // SETTING COIN
  SETTING_COIN: '/settings/coin',

  // HISTORY COIN
  COIN_HISTORIES: '/coin-histories',

  // COMPLAINTS
  COMPLAINTS: '/complaints',
  COMPLAINT_DETAIL: (id) => `/complaints/${id}`,

  // SOCIAL ORGANIZATION FEEDBACKS (PHẢN ÁNH TCXH)
  SOCIAL_ORGANIZATION_FEEDBACKS: '/social-organization-feedbacks',
  SOCIAL_ORGANIZATION_FEEDBACK_DETAIL: (id) => `/social-organization-feedbacks/${id}`,
};

export default ENDPOINT;
